import cls from "classnames";
import { useNavigate } from "react-router-dom";
// components
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface NotificationChipProps {
  color: string;
  title: string;
  route: string;
  quantity: number;
  loading: boolean;
}

export const NotificationChip = ({
  color,
  title,
  route,
  quantity,
  loading,
}: NotificationChipProps) => {
  const navigate = useNavigate();

  return (
    <div
      className={cls(
        "h:28 flex ai:center t:underline:hover cursor:pointer user-select:none",
        `fg:${color}-50 fg:${color}-40:hover`
      )}
      onClick={() => navigate(route)}
    >
      <span>{title}:</span>
      {loading ? (
        <Spin indicator={<LoadingOutlined spin className="f:12!" />} />
      ) : (
        <span>&nbsp;{quantity}</span>
      )}
    </div>
  );
};
